import {
  checkoutParcelStepSchema,
  triggerStepSchema,
} from "@redotech/redo-model/advanced-flow/advanced-flow-db-parser";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

const flowStepSchema = z.union([checkoutParcelStepSchema, triggerStepSchema]);
export type CheckoutParcelTreeFlowStep = z.infer<typeof flowStepSchema>;

export const getCheckoutExperienceParcelTreeFlowSteps = {
  name: "getCheckoutExperienceParcelTreeFlowSteps" as const,
  input: z.object({ checkoutExperienceId: zExt.objectId() }),
  output: z.object({ steps: z.array(flowStepSchema) }),
};
